import { render, staticRenderFns } from "./AdditionalInformationOld.vue?vue&type=template&id=69fe313b&"
import script from "./AdditionalInformationOld.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationOld.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports